import { __assign } from 'tslib';
import * as React from 'react';
import { useRef, useEffect } from 'react';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-seat-map.css';
import { layoutPadding, normalMapSizeThreshold, seatPadding, getSeatGridItemDimension, getCabinWidth, getTotalWidth, getTotalHeight, seatHeight, leftWingIntersectionEndCoordinate } from './utils.esm.js';

var getClassNameList = classNames.bind(styles);
var UitkSeatMapCabinLayout = function (props) {
    var children = props.children, _a = props.seatMapCabinDimensionDetails, wingDetails = _a.wingDetails, rowsCount = _a.rowsCount, columnsCount = _a.columnsCount, exitsCount = _a.exitsCount, aislesCount = _a.aislesCount;
    var cabinLayoutRef = useRef(null);
    var cabinLayoutClassName = columnsCount < normalMapSizeThreshold
        ? 'uitk-seat-map-cabin-layout-normal-size'
        : 'uitk-seat-map-cabin-layout-wrapper';
    var actualSeatCount = columnsCount - exitsCount - aislesCount;
    var heightPadding = getSeatGridItemDimension(seatHeight, seatPadding);
    var cabinWidth = getCabinWidth(actualSeatCount, exitsCount, aislesCount);
    var totalWidth = getTotalWidth(cabinWidth);
    var totalHeight = getTotalHeight(rowsCount, heightPadding);
    var points = "".concat(layoutPadding, ",0 ").concat(layoutPadding, ",").concat(totalHeight, " ").concat(cabinWidth + layoutPadding, ",").concat(totalHeight, " ").concat(cabinWidth + layoutPadding, ",0");
    if (wingDetails) {
        var wingEndRowForHeight = wingDetails.endRow + 1;
        var leftWingStartCoordinate = wingDetails.startRow * heightPadding;
        var leftWingEndCoordinate = wingEndRowForHeight * heightPadding;
        var leftWingIntersectionStartYCoordinate = (leftWingEndCoordinate - leftWingStartCoordinate) / 2 + leftWingStartCoordinate;
        var leftWingIntersectionEndYCoordinate = wingEndRowForHeight * heightPadding + leftWingIntersectionEndCoordinate;
        points = "".concat(layoutPadding, ",0 ").concat(layoutPadding, ",").concat(leftWingStartCoordinate, " 0,").concat(leftWingIntersectionStartYCoordinate, " 0,").concat(leftWingIntersectionEndYCoordinate, " ").concat(layoutPadding, ",").concat(leftWingEndCoordinate, " ").concat(layoutPadding, ",").concat(totalHeight, "\n    ").concat(layoutPadding + cabinWidth, ",").concat(totalHeight, " ").concat(layoutPadding + cabinWidth, ",").concat(leftWingEndCoordinate, " ").concat(totalWidth, ",").concat(leftWingIntersectionEndYCoordinate, " ").concat(totalWidth, ",").concat(leftWingIntersectionStartYCoordinate, " ").concat(layoutPadding + cabinWidth, ",").concat(leftWingStartCoordinate, "\n    ").concat(layoutPadding + cabinWidth, ",0");
    }
    var svgAttributes = {
        width: totalWidth,
        height: totalHeight
    };
    var svgElement = (React.createElement("svg", __assign({}, svgAttributes),
        React.createElement("polygon", { points: points, className: getClassNameList('uitk-seat-map-cabin-layout') }),
        React.createElement("foreignObject", { x: layoutPadding, y: 0, width: cabinWidth, height: totalHeight }, children)));
    useEffect(function () {
        if (columnsCount >= normalMapSizeThreshold && cabinLayoutRef.current) {
            cabinLayoutRef.current.scrollLeft = layoutPadding - seatPadding;
        }
    }, [columnsCount, totalWidth]);
    return (React.createElement("div", { className: getClassNameList(cabinLayoutClassName), ref: cabinLayoutRef }, svgElement));
};
UitkSeatMapCabinLayout.displayName = 'UitkSeatMapCabinLayout';
UitkSeatMapCabinLayout.defaultProps = {
    seatMapCabinDimensionDetails: {
        rowsCount: 10,
        columnsCount: 6,
        exitsCount: 0,
        aislesCount: 0
    }
};

export { UitkSeatMapCabinLayout };
